import actionTypes from '../webActionTypes';
import GLOBAL from '../../jcolorglobal';

const API_URL = '/TurnkeyUploadLogAction.do';


function getTurnkeyUploadLogList(payload = {}) {

    return (dispatch, getState) => {
        dispatch(beginGetTurnkeyUploadLogList(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            const start = payload.start || 0;
            var querykey = '';
            formData.append('op', 'getLogList');

            if(payload.yearmonth) {
                formData.append('yearmonth', payload.yearmonth);
                querykey += payload.yearmonth;
            }

            if(payload.invoiceNumber) {
                formData.append('invoiceNumber', payload.invoiceNumber);
                querykey += payload.invoiceNumber;
            }

            if(payload.srcType) {
                formData.append('srcType', payload.srcType);
                querykey += payload.srcType;
            }

            if(payload.xmlformat) {
                formData.append('xmlformat', payload.xmlformat);
                querykey += payload.xmlformat;
            }

            if(!isNaN(payload.starttime) && payload.starttime > 0) {
                formData.append('starttime', payload.starttime);
                querykey += payload.starttime;
            }
            if(!isNaN(payload.endtime) && payload.endtime > 0) {
                formData.append('endtime', parseInt(payload.endtime, 10) + 24 * 60 * 60 * 1000 );
                querykey += payload.endtime;
            }

            formData.append('start', start || 0);
            formData.append('len', getState().turnkeyUploadLog.pageLen || 20);

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            }).then(response => {
                    
                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    if(result.error) {
                        reject(result.error);
                        return 
                    }

                    // 拆解list result成id list and data map兩組資料
                    let ids = {};
                    let data = {};
                    // eslint-disable-next-line
                    result.list.map((listitem, index) => {
                        const id = listitem.logid;
                        ids[start+index] = id;
                        data[id] = listitem;

                    });
                    const { totalCount } = result;

                    dispatch(recvGetTurnkeyUploadLogListResult({ids, data, start, totalCount, querykey}));
                    resolve(result);
                }).catch(error => {
                    dispatch(recvGetTurnkeyUploadLogListError(error));
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                dispatch(recvGetTurnkeyUploadLogListError(error));
                reject(error);
            });
        });

        return promise;

    };
}

function getTurnkeyUploadLogYearmonthList() {
    return (dispatch, getState) => {

        const promise = new Promise((resolve, reject) => {

            const url = API_URL + '?op=getTurnkeyUploadLogYearmonthList';

            GLOBAL.fetchWithCookies(url, {
                method: 'GET',
            }).then(response => {
                    
                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    dispatch(finishGetTurnkeyUploadLogYearmonthList(result));
                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                reject(error);
            });
        });

        return promise;
    };
}

function beginGetTurnkeyUploadLogList(payload) {
    return { type: actionTypes.beginGetTurnkeyUploadLogList, payload };
}

function recvGetTurnkeyUploadLogListResult(payload) {
    return { type: actionTypes.recvGetTurnkeyUploadLogListResult, payload };
}

function recvGetTurnkeyUploadLogListError(payload) {
    return { type: actionTypes.recvGetTurnkeyUploadLogListError, payload };
}

function finishGetTurnkeyUploadLogYearmonthList(yearmonthList) {
    return { type: actionTypes.finishGetTurnkeyUploadLogYearmonthList, payload: { yearmonthList: yearmonthList } };
}

const TurnkeyUploadLogActions = {
    getTurnkeyUploadLogList,
    getTurnkeyUploadLogYearmonthList,
};

export default TurnkeyUploadLogActions;


// WEBPACK FOOTER //
// ./src/actions/creators/turnkeyUploadLogActions.js